import { render, staticRenderFns } from "./SocialFilter.vue?vue&type=template&id=cb608daa&scoped=true"
import script from "./SocialFilter.vue?vue&type=script&lang=js"
export * from "./SocialFilter.vue?vue&type=script&lang=js"
import style0 from "./SocialFilter.vue?vue&type=style&index=0&id=cb608daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb608daa",
  null
  
)

export default component.exports